module.exports = __webpack_public_path__ + "img/spittaler-leben.a5814075.svg";